import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'
import { Creators as ClientTicketModalCreators } from '../../../../../ducks/client-ticket-modal/client-ticket-modal'
import PurchasePagination from './purchase-pagination.component'

class PurchasePaginationComponent extends React.Component {
	render() {
		const {
			params,
			hideLoading,
			showLoading,
			openQrCodeModal,
			forceReloadData,
			getPurchaseTickets,
			openClientTicketModal,
		} = this.props

		return (
			<PurchasePagination
				params={params}
				hideLoading={hideLoading}
				showLoading={showLoading}
				openQrCodeModal={openQrCodeModal}
				forceReloadData={forceReloadData}
				getPurchaseTickets={getPurchaseTickets}
				openClientTicketModal={openClientTicketModal}
			/>
		)
	}
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
			getPurchaseTickets: ClientTicketModalCreators.fetchData,
			openQrCodeModal: ClientTicketModalCreators.openQrCodeModal,
			openClientTicketModal: ClientTicketModalCreators.openModal,
		},
		dispatch
	)

const PurchasePaginationContainer = connect(
	null,
	mapDispatchToProps
)(PurchasePaginationComponent)

export default PurchasePaginationContainer
